<template>
  <table class="table table-striped table-hover">
    <thead>
      <tr class="d-flex">
        <th class="col-1">
          #
        </th>
        <th class="col-5">
          <strong>Supply</strong>
        </th>
        <th class="col-2">
          <strong>Quantity Balance</strong>
        </th>
        <th class="col-2">
          <strong>Total Records</strong>
        </th>
        <th class="col-2" />
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(currentSupply) in supplies"
        :key="currentSupply.id"
        class="d-flex"
        :class="{'table-success': supply && currentSupply.id == supply.id}"
        style="cursor: pointer;"
        @click="selectSupply(currentSupply)"
      >
        <td class="col-1">
          {{ currentSupply.id }}
        </td>
        <td class="col-5">
          {{ currentSupply.name }}
        </td>
        <td class="col-2">
          {{ transactionsSummary[currentSupply.id] ? transactionsSummary[currentSupply.id].quantity_balance : 0 }}
        </td>
        <td class="col-2">
          {{ transactionsSummary[currentSupply.id] ? transactionsSummary[currentSupply.id].total_transactions : 0 }}
        </td>
        <td class="col-2">
          <a
            v-if=" ! transactionsSummary[currentSupply.id]"
            href="#"
            class="decorated"
            @click="removeSupply(currentSupply)"
          >Delete</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  props: ['supply', 'supplies', 'transactionsSummary'],
  emits: ['select-supply', 'remove-supply'],
  data() {
    return { };
  },

  methods: {
    selectSupply(supply) {
      this.$emit('select-supply', supply);
    },

    removeSupply(supply) {
      this.$emit('remove-supply', supply);
    },
  },
};
</script>
